import React, { useEffect, useState, useRef } from "react";
import Constants from "../constants/Constants";
const POPUP_CLASS = "show_popup";
const PopUp = ({ join, model, dispatch, biller }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [withError, setWithError] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const polling = useRef(null);
  const closeDownJoin = () => {
    document.body.classList.remove(POPUP_CLASS);
    setTimeout(() => join({}), 500);
  };
  const startPolling = (tok, newWindow) => {
    let evtSource = new EventSource(`${Constants.API}mjs.php?tok=${tok}`);
    polling.current = evtSource;

    evtSource.onopen = function() {
      console.log("Checking with the 7 about the new site.");
    };

    evtSource.onmessage = function(e) {
      if (e.data === "SUCCESS!") {
        const needthis = {
          siteid: model.id,
          biller_expires: "0",
        };
        setIsProcessing(false);
        setIsConfirmed(true);
        dispatch({
          type: "addMembership",
          payload: needthis,
          siteid: model.id,
        });
        newWindow.close();
        evtSource.close();
      } else if (e.data === "STOP!") {
        setIsProcessing(false);
        setIsConfirmed(true);
        setWithError(true);
        newWindow.close();
        evtSource.close();
        //Need to NOT close window and forward on to join page.
        //newWindow.location = "https://www.imagepost.com/";

        //https://join.addfriends.com/strack/MC4wLjE3LjI0LjAuMC4wLjAuMA/17/0/1/join?step=signup&cascade=14&signup%5Boptionid%5D=130&nats=MC4wLjE3LjI0LjAuMC4wLjAuMA&nextra%5BEPOCH%5D%5Bsite_subcat%5D=ScarlettSageSnap&nextra%5BEPOCH%5D%5Btopimage%5D=604239_addfriends-scarlett-sage.png&signup%5Busername%2Cemail%3A1%3A1%3A128%3A%3A%3Aemail_check%5D=myemail%40email.com&signup%5Bcustom1%5D=mysnapchat&signup%5Bpassword%3A1%3A6%3A16%3A%3A%3Apassword_check_detailed%3B0%7C0%7C0%7C0%7C0%7C0%7C0%5D=mypassword&signup%5Bcustom2%5D=
      } else {
        console.log("...");
      }
    };

    evtSource.onerror = function() {
      setIsProcessing(false);
      setIsConfirmed(true);
      setWithError(true);
      evtSource.close();
      console.log("joined failed.");
    };

    //evtSource.close();
  };
  const makePurchase = (newWindow) => {
    setIsProcessing(true);
    let formData = new FormData();
    formData.append("siteid", model.id);
    fetch(`${Constants.API}request-upgrade.php`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (!("error" in res)) {
          // setTimeout(() => {
          //   newWindow.location = res.url;
          // }, 3000);
          if ("success" in res) {
            if (res.success === "yes") {
              setTimeout(() => {
                const needthis = {
                  siteid: model.id,
                  biller_expires: "0",
                };
                setIsProcessing(false);
                setIsConfirmed(true);
                dispatch({
                  type: "addMembership",
                  payload: needthis,
                  siteid: model.id,
                });
              }, 2000);
            } else {
              setIsProcessing(false);
              setIsConfirmed(true);
              setWithError(true);
              if (newWindow) {
                newWindow.close();
              }
            }
          } else {
            newWindow.location = res.url;
            startPolling(res.poll, newWindow);
          }
        } else {
          newWindow.close();
          window.location = `https://join.addfriends.com/strack/${res.nats}/${
            model.id
          }:river/0/1/join?step=signup&cascade=14&signup%5Boptionid%5D=${
            res.option
          }&nats=${res.nats}&nextra%5BEPOCH%5D%5Bsite_subcat%5D=${
            model.site_url
          }&signup%5Busername%2Cemail%3A1%3A1%3A128%3A%3A%3Aemail_check%5D=${encodeURIComponent(
            res.username
          )}&signup%5Bcustom1%5D=${
            res.snap
          }&signup%5Bpassword%3A1%3A6%3A16%3A%3A%3Apassword_check_detailed%3B0%7C0%7C0%7C0%7C0%7C0%7C0%5D=${
            res.pass
          }&signup%5Bcustom2%5D=&chek_radio=on`;
        }
      })
      .catch((error) => console.log(error));
    // setTimeout(() => {
    //   setIsConfirmed(true);
    //   const needthis = {
    //     siteid: "13",
    //     biller_expires: "0"
    //   };
    //   addASite(needthis);
    // }, 4000);
  };
  useEffect(() => {
    document.body.classList.add(POPUP_CLASS);
    return () => {
      if (polling.current) {
        polling.current.close();
      }

      document.body.classList.remove(POPUP_CLASS);
    };
  }, []);
  return (
    <div className="popup">
      <div className="popup_modal">
        <button
          type="button"
          className="popup_close"
          id="popup_close"
          onClick={closeDownJoin}
        >
          <i className="icon-close" />
        </button>
        <div className="avatar">
          <img
            src={`https://static.addfriends.com/images/sites/${model.site_url}-big.jpg`}
            alt={model.site_name}
          />
        </div>
        <div className="content">
          Add <strong>{model.site_name}</strong> To Your Subscriptions for{" "}
          <strong>{model.u_price}</strong>?
        </div>
        <div className={isProcessing ? "bottom processing" : "bottom"}>
          <button
            type="button"
            className={
              isConfirmed
                ? withError
                  ? "button buttonChoice confirmed withError"
                  : "button buttonChoice confirmed"
                : "button buttonChoice"
            }
            onClick={() => {
              if (isConfirmed || withError) {
                closeDownJoin();
                return;
              }
              let newWindow = null;
              if (biller !== 14) {
                newWindow = window.open(
                  "https://addfriends.com/robots-working/",
                  "_blank"
                );
              }

              makePurchase(newWindow);
            }}
          >
            {isProcessing
              ? "Processing..."
              : withError
              ? "FAILED"
              : isConfirmed
              ? "Success!"
              : "Confirm"}
            <div className="nk-spinner" />
            {withError ? (
              <span className="close" />
            ) : (
              <span className="checked" />
            )}
          </button>
          <div className="hide_link">
            <a href="https://addfriends.com/contact-us">Contact support</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
